webpackJsonp(["pages.projects.cycle_analytics.show"],{

/***/ "../../views/shared/icons/_icon_cycle_analytics_splash.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 99 102\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path id=\"0\" d=\"m35.12 56.988c4.083-4.385 5.968-12.155 5.968-24.04 0-20.2-15.874-32.16-15.874-32.16-1.114-.954-2.929-.979-4.04 0 0 0-15.874 11.957-15.874 32.16 0 11.882 1.884 19.652 5.968 24.04h23.848\"/><mask id=\"1\" width=\"35.783\" height=\"56.924\" x=\"0\" y=\"0\" fill=\"#fff\"><use xlink:href=\"#0\"/></mask></defs><g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(0-4)\"><g transform=\"translate(32.15 3.976)\"><g fill=\"#6b4fbb\"><path d=\"m11.928 56.988l1.325-1.325v3.313c0 .737.59 1.325 1.325 1.325h17.229c.736 0 1.325-.59 1.325-1.325v-3.313l1.325 1.325h-22.53m22.53-1.325v3.313c0 1.464-1.18 2.651-2.651 2.651h-17.229c-1.464 0-2.651-1.178-2.651-2.651v-3.313h22.53m-5.964 7.361h.663c0 3.294-2.67 5.964-5.964 5.964-3.294 0-5.964-2.67-5.964-5.964h.663.663c0 2.562 2.077 4.639 4.639 4.639 2.562 0 4.639-2.077 4.639-4.639h.663\"/><path d=\"m5.816 42.535c-.346-2.839-.515-6.03-.515-9.584 0-20.2 15.874-32.16 15.874-32.16 1.106-.979 2.921-.954 4.04 0 0 0 15.874 11.957 15.874 32.16 0 11.882-1.884 19.652-5.968 24.04h-23.848c-2.861-3.073-4.643-7.807-5.453-14.453-.06-.493-.115-.997-.164-1.511l-4.04 2.884c-.891.637-1.614 2.041-1.614 3.137v14.581c0 1.465.971 1.958 2.165 1.106l8.691-6.208c-.282-.332-.553-.681-.813-1.048l-8.648 6.177c-.147.105-.069.152-.069-.027v-14.581c0-.668.516-1.671 1.059-2.059l3.432-2.451m38.4 20.2c1.193.852 2.165.359 2.165-1.106v-14.581c0-1.096-.723-2.5-1.614-3.137l-4.04-2.884c-.049.514-.104 1.018-.164 1.511l3.432 2.451c.543.388 1.059 1.391 1.059 2.059v14.581c0 .179.078.132-.069.027l-8.648-6.177c-.26.367-.531.716-.813 1.048l8.691 6.208\"/></g><use fill=\"#fff\" stroke=\"#6b4fbb\" stroke-width=\"2.651\" mask=\"url(#1)\" xlink:href=\"#0\"/><g fill=\"#b5a7dd\"><path d=\"m30.482 28.494c0-4.03-3.263-7.289-7.289-7.289-4.03 0-7.289 3.263-7.289 7.289 0 4.03 3.263 7.289 7.289 7.289 4.03 0 7.289-3.263 7.289-7.289m-15.904 0c0-4.758 3.857-8.614 8.614-8.614 4.758 0 8.614 3.857 8.614 8.614 0 4.758-3.857 8.614-8.614 8.614-4.758 0-8.614-3.857-8.614-8.614\"/><path d=\"m27.17 28.494c0-2.196-1.78-3.976-3.976-3.976-2.196 0-3.976 1.78-3.976 3.976 0 2.196 1.78 3.976 3.976 3.976 2.196 0 3.976-1.78 3.976-3.976m-9.277 0c0-2.928 2.373-5.301 5.301-5.301 2.928 0 5.301 2.373 5.301 5.301 0 2.928-2.373 5.301-5.301 5.301-2.928 0-5.301-2.373-5.301-5.301\"/></g><path fill=\"#6b4fbb\" d=\"m34.458 87.47c0 1.098.89 1.988 1.988 1.988 1.098 0 1.988-.89 1.988-1.988 0-.366.297-.663.663-.663.366 0 .663.297.663.663 0 1.83-1.483 3.313-3.313 3.313-1.826 0-3.307-1.478-3.313-3.302 0-.002 0-.003 0-.005v-2.663c0-.363.294-.657.663-.657.366 0 .663.299.663.657v2.657m-21.2-6.615c0-.002 0-.003 0-.005v-2.663c0-.358-.297-.657-.663-.657-.369 0-.663.294-.663.657v2.657c0 1.098-.89 1.988-1.988 1.988-1.098 0-1.988-.89-1.988-1.988 0-.366-.297-.663-.663-.663-.366 0-.663.297-.663.663 0 1.83 1.483 3.313 3.313 3.313 1.826 0 3.307-1.477 3.313-3.302m5.301 7.285c0-.001 0-.002 0-.003v-16.576c0-.362-.297-.658-.663-.658-.369 0-.663.295-.663.658v16.571c0 2.01-1.632 3.645-3.645 3.645-2.01 0-3.645-1.632-3.645-3.645 0-.366-.297-.663-.663-.663-.366 0-.663.297-.663.663 0 2.745 2.225 4.97 4.97 4.97 2.742 0 4.966-2.221 4.97-4.963m10.602 8.607v-18.555c0-.365-.297-.661-.663-.661-.369 0-.663.296-.663.661v18.557c0 0 0 0 0 .001.001 2.744 2.226 4.968 4.97 4.968 2.745 0 4.97-2.225 4.97-4.97 0-.366-.297-.663-.663-.663-.366 0-.663.297-.663.663 0 2.01-1.632 3.645-3.645 3.645-2.01 0-3.645-1.632-3.645-3.645m3.976-25.19c0-.363.294-.657.663-.657.366 0 .663.299.663.657v2.663c0 .363-.294.657-.663.657-.366 0-.663-.299-.663-.657v-2.663m0 6.627c0-.363.294-.657.663-.657.366 0 .663.299.663.657v2.663c0 .363-.294.657-.663.657-.366 0-.663-.299-.663-.657v-2.663m-10.602-6.627c0-.363.294-.657.663-.657.366 0 .663.299.663.657v2.663c0 .363-.294.657-.663.657-.366 0-.663-.299-.663-.657v-2.663m5.301 0c0-.363.294-.657.663-.657.366 0 .663.299.663.657v2.663c0 .363-.294.657-.663.657-.366 0-.663-.299-.663-.657v-2.663m-5.301 6.627c0-.363.294-.657.663-.657.366 0 .663.299.663.657v2.663c0 .363-.294.657-.663.657-.366 0-.663-.299-.663-.657v-2.663m0 6.627c0-.363.294-.657.663-.657.366 0 .663.299.663.657v2.663c0 .363-.294.657-.663.657-.366 0-.663-.299-.663-.657v-2.663m-10.602-13.253c0-.363.294-.657.663-.657.366 0 .663.299.663.657v2.663c0 .363-.294.657-.663.657-.366 0-.663-.299-.663-.657v-2.663\"/></g><path fill=\"#e2ddf2\" d=\"m97.75 76.54c0-2.745-2.225-4.97-4.97-4.97-2.745 0-4.97 2.225-4.97 4.97 0 2.745 2.225 4.97 4.97 4.97 2.745 0 4.97-2.225 4.97-4.97m-8.614 0c0-2.01 1.632-3.645 3.645-3.645 2.01 0 3.645 1.632 3.645 3.645 0 2.01-1.632 3.645-3.645 3.645-2.01 0-3.645-1.632-3.645-3.645m-60.964-57.651c0-2.745-2.225-4.97-4.97-4.97-2.745 0-4.97 2.225-4.97 4.97 0 2.745 2.225 4.97 4.97 4.97 2.745 0 4.97-2.225 4.97-4.97m-8.614 0c0-2.01 1.632-3.645 3.645-3.645 2.01 0 3.645 1.632 3.645 3.645 0 2.01-1.632 3.645-3.645 3.645-2.01 0-3.645-1.632-3.645-3.645\"/><path fill=\"#b5a7dd\" d=\"m98.41 34.458c0-1.83-1.483-3.313-3.313-3.313-1.83 0-3.313 1.483-3.313 3.313 0 1.83 1.483 3.313 3.313 3.313 1.83 0 3.313-1.483 3.313-3.313m-5.301 0c0-1.098.89-1.988 1.988-1.988 1.098 0 1.988.89 1.988 1.988 0 1.098-.89 1.988-1.988 1.988-1.098 0-1.988-.89-1.988-1.988m-86.14 20.542c0-1.83-1.483-3.313-3.313-3.313-1.83 0-3.313 1.483-3.313 3.313 0 1.83 1.483 3.313 3.313 3.313 1.83 0 3.313-1.483 3.313-3.313m-5.301 0c0-1.098.89-1.988 1.988-1.988 1.098 0 1.988.89 1.988 1.988 0 1.098-.89 1.988-1.988 1.988-1.098 0-1.988-.89-1.988-1.988\"/></g></svg>\n"

/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./cycle_analytics/components/banner.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_cycle_analytics_splash.svg
var _icon_cycle_analytics_splash = __webpack_require__("../../views/shared/icons/_icon_cycle_analytics_splash.svg");
var _icon_cycle_analytics_splash_default = /*#__PURE__*/__webpack_require__.n(_icon_cycle_analytics_splash);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./cycle_analytics/components/banner.vue



/* harmony default export */ var banner = ({
  props: {
    documentationLink: {
      type: String,
      required: true
    }
  },
  computed: {
    iconCycleAnalyticsSplash: function iconCycleAnalyticsSplash() {
      return _icon_cycle_analytics_splash_default.a;
    }
  },
  methods: {
    dismissOverviewDialog: function dismissOverviewDialog() {
      this.$emit('dismiss-overview-dialog');
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e9f08fa","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./cycle_analytics/components/banner.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing content-block"},[_c('button',{staticClass:"js-ca-dismiss-button dismiss-button",attrs:{"type":"button","aria-label":_vm.__('Dismiss Cycle Analytics introduction box')},on:{"click":_vm.dismissOverviewDialog}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"svg-container",domProps:{"innerHTML":_vm._s(_vm.iconCycleAnalyticsSplash)}}),_vm._v(" "),_c('div',{staticClass:"inner-content"},[_c('h4',[_vm._v("\n        "+_vm._s(_vm.__('Introducing Cycle Analytics'))+"\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        "+_vm._s(_vm.__("Cycle Analytics gives an overview\nof how much time it takes to go from idea to production in your project."))+"\n      ")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn",attrs:{"href":_vm.documentationLink,"target":"_blank","rel":"nofollow"}},[_vm._v("\n          "+_vm._s(_vm.__('Read more'))+"\n        ")])])])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./cycle_analytics/components/banner.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  banner,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_banner = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./cycle_analytics/components/limit_warning_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./cycle_analytics/components/limit_warning_component.vue



/* harmony default export */ var limit_warning_component = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    count: {
      type: Number,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3243e6e8","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./cycle_analytics/components/limit_warning_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count === 50)?_c('span',{staticClass:"events-info pull-right"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"fa fa-warning",attrs:{"aria-hidden":"true","title":_vm.n__(
      'Limited to showing %d event at most',
      'Limited to showing %d events at most',
      50
    ),"data-placement":"top"}}),_vm._v("\n  "+_vm._s(_vm.n__('Showing %d event', 'Showing %d events', 50))+"\n")]):_vm._e()}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./cycle_analytics/components/limit_warning_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  limit_warning_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_limit_warning_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./cycle_analytics/components/stage_code_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// EXTERNAL MODULE: ./cycle_analytics/components/limit_warning_component.vue + 2 modules
var limit_warning_component = __webpack_require__("./cycle_analytics/components/limit_warning_component.vue");

// EXTERNAL MODULE: ./cycle_analytics/components/total_time_component.vue + 2 modules
var total_time_component = __webpack_require__("./cycle_analytics/components/total_time_component.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./cycle_analytics/components/stage_code_component.vue





/* harmony default export */ var stage_code_component = ({
  components: {
    userAvatarImage: user_avatar_image["a" /* default */],
    limitWarning: limit_warning_component["a" /* default */],
    totalTime: total_time_component["a" /* default */]
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    stage: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c77388","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./cycle_analytics/components/stage_code_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"events-description"},[_vm._v("\n    "+_vm._s(_vm.stage.description)+"\n    "),_c('limit-warning',{attrs:{"count":_vm.items.length}})],1),_vm._v(" "),_c('ul',{staticClass:"stage-event-list"},_vm._l((_vm.items),function(mergeRequest,i){return _c('li',{key:i,staticClass:"stage-event-item"},[_c('div',{staticClass:"item-details"},[_c('user-avatar-image',{attrs:{"img-src":mergeRequest.author.avatarUrl}}),_vm._v(" "),_c('h5',{staticClass:"item-title merge-merquest-title"},[_c('a',{attrs:{"href":mergeRequest.url}},[_vm._v("\n            "+_vm._s(mergeRequest.title)+"\n          ")])]),_vm._v(" "),_c('a',{staticClass:"issue-link",attrs:{"href":mergeRequest.url}},[_vm._v("\n          !"+_vm._s(mergeRequest.iid)+"\n        ")]),_vm._v("\n        ·\n        "),_c('span',[_vm._v("\n          "+_vm._s(_vm.s__('OpenedNDaysAgo|Opened'))+"\n          "),_c('a',{staticClass:"issue-date",attrs:{"href":mergeRequest.url}},[_vm._v("\n            "+_vm._s(mergeRequest.createdAt)+"\n          ")])]),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(_vm.s__('ByAuthor|by'))+"\n          "),_c('a',{staticClass:"issue-author-link",attrs:{"href":mergeRequest.author.webUrl}},[_vm._v("\n            "+_vm._s(mergeRequest.author.name)+"\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"item-time"},[_c('total-time',{attrs:{"time":mergeRequest.totalTime}})],1)])}))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./cycle_analytics/components/stage_code_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  stage_code_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_stage_code_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./cycle_analytics/components/stage_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// EXTERNAL MODULE: ./cycle_analytics/components/limit_warning_component.vue + 2 modules
var limit_warning_component = __webpack_require__("./cycle_analytics/components/limit_warning_component.vue");

// EXTERNAL MODULE: ./cycle_analytics/components/total_time_component.vue + 2 modules
var total_time_component = __webpack_require__("./cycle_analytics/components/total_time_component.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./cycle_analytics/components/stage_component.vue





/* harmony default export */ var stage_component = ({
  components: {
    userAvatarImage: user_avatar_image["a" /* default */],
    limitWarning: limit_warning_component["a" /* default */],
    totalTime: total_time_component["a" /* default */]
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    stage: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79a02633","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./cycle_analytics/components/stage_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"events-description"},[_vm._v("\n    "+_vm._s(_vm.stage.description)+"\n    "),_c('limit-warning',{attrs:{"count":_vm.items.length}})],1),_vm._v(" "),_c('ul',{staticClass:"stage-event-list"},_vm._l((_vm.items),function(issue,i){return _c('li',{key:i,staticClass:"stage-event-item"},[_c('div',{staticClass:"item-details"},[_c('user-avatar-image',{attrs:{"img-src":issue.author.avatarUrl}}),_vm._v(" "),_c('h5',{staticClass:"item-title issue-title"},[_c('a',{staticClass:"issue-title",attrs:{"href":issue.url}},[_vm._v("\n            "+_vm._s(issue.title)+"\n          ")])]),_vm._v(" "),_c('a',{staticClass:"issue-link",attrs:{"href":issue.url}},[_vm._v("#"+_vm._s(issue.iid))]),_vm._v("\n        ·\n        "),_c('span',[_vm._v("\n          "+_vm._s(_vm.s__('OpenedNDaysAgo|Opened'))+"\n          "),_c('a',{staticClass:"issue-date",attrs:{"href":issue.url}},[_vm._v(_vm._s(issue.createdAt))])]),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(_vm.s__('ByAuthor|by'))+"\n          "),_c('a',{staticClass:"issue-author-link",attrs:{"href":issue.author.webUrl}},[_vm._v("\n            "+_vm._s(issue.author.name)+"\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"item-time"},[_c('total-time',{attrs:{"time":issue.totalTime}})],1)])}))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./cycle_analytics/components/stage_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  stage_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_stage_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./cycle_analytics/components/stage_plan_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// EXTERNAL MODULE: ./cycle_analytics/svg/icon_commit.svg
var icon_commit = __webpack_require__("./cycle_analytics/svg/icon_commit.svg");
var icon_commit_default = /*#__PURE__*/__webpack_require__.n(icon_commit);

// EXTERNAL MODULE: ./cycle_analytics/components/limit_warning_component.vue + 2 modules
var limit_warning_component = __webpack_require__("./cycle_analytics/components/limit_warning_component.vue");

// EXTERNAL MODULE: ./cycle_analytics/components/total_time_component.vue + 2 modules
var total_time_component = __webpack_require__("./cycle_analytics/components/total_time_component.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./cycle_analytics/components/stage_plan_component.vue






/* harmony default export */ var stage_plan_component = ({
  components: {
    userAvatarImage: user_avatar_image["a" /* default */],
    totalTime: total_time_component["a" /* default */],
    limitWarning: limit_warning_component["a" /* default */]
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    stage: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    iconCommit: function iconCommit() {
      return icon_commit_default.a;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ff345cf","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./cycle_analytics/components/stage_plan_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"events-description"},[_vm._v("\n    "+_vm._s(_vm.stage.description)+"\n    "),_c('limit-warning',{attrs:{"count":_vm.items.length}})],1),_vm._v(" "),_c('ul',{staticClass:"stage-event-list"},_vm._l((_vm.items),function(commit,i){return _c('li',{key:i,staticClass:"stage-event-item"},[_c('div',{staticClass:"item-details item-conmmit-component"},[_c('user-avatar-image',{attrs:{"img-src":commit.author.avatarUrl}}),_vm._v(" "),_c('h5',{staticClass:"item-title commit-title"},[_c('a',{attrs:{"href":commit.commitUrl}},[_vm._v("\n            "+_vm._s(commit.title)+"\n          ")])]),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(_vm.s__('FirstPushedBy|First'))+"\n          "),_c('span',{staticClass:"commit-icon",domProps:{"innerHTML":_vm._s(_vm.iconCommit)}}),_vm._v(" "),_c('a',{staticClass:"commit-hash-link commit-sha",attrs:{"href":commit.commitUrl}},[_vm._v(_vm._s(commit.shortSha))]),_vm._v("\n          "+_vm._s(_vm.s__('FirstPushedBy|pushed by'))+"\n          "),_c('a',{staticClass:"commit-author-link",attrs:{"href":commit.author.webUrl}},[_vm._v("\n            "+_vm._s(commit.author.name)+"\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"item-time"},[_c('total-time',{attrs:{"time":commit.totalTime}})],1)])}))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./cycle_analytics/components/stage_plan_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  stage_plan_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_stage_plan_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./cycle_analytics/components/stage_review_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// EXTERNAL MODULE: ./cycle_analytics/components/limit_warning_component.vue + 2 modules
var limit_warning_component = __webpack_require__("./cycle_analytics/components/limit_warning_component.vue");

// EXTERNAL MODULE: ./cycle_analytics/components/total_time_component.vue + 2 modules
var total_time_component = __webpack_require__("./cycle_analytics/components/total_time_component.vue");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./cycle_analytics/components/stage_review_component.vue






/* harmony default export */ var stage_review_component = ({
  components: {
    userAvatarImage: user_avatar_image["a" /* default */],
    totalTime: total_time_component["a" /* default */],
    limitWarning: limit_warning_component["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    stage: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0126fec","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./cycle_analytics/components/stage_review_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"events-description"},[_vm._v("\n    "+_vm._s(_vm.stage.description)+"\n    "),_c('limit-warning',{attrs:{"count":_vm.items.length}})],1),_vm._v(" "),_c('ul',{staticClass:"stage-event-list"},_vm._l((_vm.items),function(mergeRequest,i){return _c('li',{key:i,staticClass:"stage-event-item"},[_c('div',{staticClass:"item-details"},[_c('user-avatar-image',{attrs:{"img-src":mergeRequest.author.avatarUrl}}),_vm._v(" "),_c('h5',{staticClass:"item-title merge-merquest-title"},[_c('a',{attrs:{"href":mergeRequest.url}},[_vm._v("\n            "+_vm._s(mergeRequest.title)+"\n          ")])]),_vm._v(" "),_c('a',{staticClass:"issue-link",attrs:{"href":mergeRequest.url}},[_vm._v("!"+_vm._s(mergeRequest.iid))]),_vm._v("\n        ·\n        "),_c('span',[_vm._v("\n          "+_vm._s(_vm.s__('OpenedNDaysAgo|Opened'))+"\n          "),_c('a',{staticClass:"issue-date",attrs:{"href":mergeRequest.url}},[_vm._v(_vm._s(mergeRequest.createdAt))])]),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(_vm.s__('ByAuthor|by'))+"\n          "),_c('a',{staticClass:"issue-author-link",attrs:{"href":mergeRequest.author.webUrl}},[_vm._v(_vm._s(mergeRequest.author.name))])]),_vm._v(" "),(mergeRequest.state === 'closed')?[_c('span',{staticClass:"merge-request-state"},[_c('i',{staticClass:"fa fa-ban",attrs:{"aria-hidden":"true"}}),_vm._v("\n            "+_vm._s(mergeRequest.state.toUpperCase())+"\n          ")])]:[(mergeRequest.branch)?_c('span',{staticClass:"merge-request-branch"},[_c('icon',{attrs:{"name":"fork","size":16}}),_vm._v(" "),_c('a',{attrs:{"href":mergeRequest.branch.url}},[_vm._v("\n              "+_vm._s(mergeRequest.branch.name)+"\n            ")])],1):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"item-time"},[_c('total-time',{attrs:{"time":mergeRequest.totalTime}})],1)])}))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./cycle_analytics/components/stage_review_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  stage_review_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_stage_review_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./cycle_analytics/components/stage_staging_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// EXTERNAL MODULE: ./cycle_analytics/svg/icon_branch.svg
var icon_branch = __webpack_require__("./cycle_analytics/svg/icon_branch.svg");
var icon_branch_default = /*#__PURE__*/__webpack_require__.n(icon_branch);

// EXTERNAL MODULE: ./cycle_analytics/components/limit_warning_component.vue + 2 modules
var limit_warning_component = __webpack_require__("./cycle_analytics/components/limit_warning_component.vue");

// EXTERNAL MODULE: ./cycle_analytics/components/total_time_component.vue + 2 modules
var total_time_component = __webpack_require__("./cycle_analytics/components/total_time_component.vue");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./cycle_analytics/components/stage_staging_component.vue







/* harmony default export */ var stage_staging_component = ({
  components: {
    userAvatarImage: user_avatar_image["a" /* default */],
    totalTime: total_time_component["a" /* default */],
    limitWarning: limit_warning_component["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    stage: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    iconBranch: function iconBranch() {
      return icon_branch_default.a;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-037af442","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./cycle_analytics/components/stage_staging_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"events-description"},[_vm._v("\n    "+_vm._s(_vm.stage.description)+"\n    "),_c('limit-warning',{attrs:{"count":_vm.items.length}})],1),_vm._v(" "),_c('ul',{staticClass:"stage-event-list"},_vm._l((_vm.items),function(build,i){return _c('li',{key:i,staticClass:"stage-event-item item-build-component"},[_c('div',{staticClass:"item-details"},[_c('user-avatar-image',{attrs:{"img-src":build.author.avatarUrl}}),_vm._v(" "),_c('h5',{staticClass:"item-title"},[_c('a',{staticClass:"pipeline-id",attrs:{"href":build.url}},[_vm._v("\n            #"+_vm._s(build.id)+"\n          ")]),_vm._v(" "),_c('icon',{attrs:{"name":"fork","size":16}}),_vm._v(" "),_c('a',{staticClass:"ref-name",attrs:{"href":build.branch.url}},[_vm._v("\n            "+_vm._s(build.branch.name)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"icon-branch",domProps:{"innerHTML":_vm._s(_vm.iconBranch)}}),_vm._v(" "),_c('a',{staticClass:"commit-sha",attrs:{"href":build.commitUrl}},[_vm._v("\n            "+_vm._s(build.shortSha)+"\n          ")])],1),_vm._v(" "),_c('span',[_c('a',{staticClass:"build-date",attrs:{"href":build.url}},[_vm._v("\n            "+_vm._s(build.date)+"\n          ")]),_vm._v("\n          "+_vm._s(_vm.s__('ByAuthor|by'))+"\n          "),_c('a',{staticClass:"issue-author-link",attrs:{"href":build.author.webUrl}},[_vm._v("\n            "+_vm._s(build.author.name)+"\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"item-time"},[_c('total-time',{attrs:{"time":build.totalTime}})],1)])}))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./cycle_analytics/components/stage_staging_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  stage_staging_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_stage_staging_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./cycle_analytics/components/stage_test_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./cycle_analytics/svg/icon_build_status.svg
var icon_build_status = __webpack_require__("./cycle_analytics/svg/icon_build_status.svg");
var icon_build_status_default = /*#__PURE__*/__webpack_require__.n(icon_build_status);

// EXTERNAL MODULE: ./cycle_analytics/svg/icon_branch.svg
var icon_branch = __webpack_require__("./cycle_analytics/svg/icon_branch.svg");
var icon_branch_default = /*#__PURE__*/__webpack_require__.n(icon_branch);

// EXTERNAL MODULE: ./cycle_analytics/components/limit_warning_component.vue + 2 modules
var limit_warning_component = __webpack_require__("./cycle_analytics/components/limit_warning_component.vue");

// EXTERNAL MODULE: ./cycle_analytics/components/total_time_component.vue + 2 modules
var total_time_component = __webpack_require__("./cycle_analytics/components/total_time_component.vue");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./cycle_analytics/components/stage_test_component.vue







/* harmony default export */ var stage_test_component = ({
  components: {
    totalTime: total_time_component["a" /* default */],
    limitWarning: limit_warning_component["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    stage: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    iconBuildStatus: function iconBuildStatus() {
      return icon_build_status_default.a;
    },
    iconBranch: function iconBranch() {
      return icon_branch_default.a;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6742412f","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./cycle_analytics/components/stage_test_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"events-description"},[_vm._v("\n    "+_vm._s(_vm.stage.description)+"\n    "),_c('limit-warning',{attrs:{"count":_vm.items.length}})],1),_vm._v(" "),_c('ul',{staticClass:"stage-event-list"},_vm._l((_vm.items),function(build,i){return _c('li',{key:i,staticClass:"stage-event-item item-build-component"},[_c('div',{staticClass:"item-details"},[_c('h5',{staticClass:"item-title"},[_c('span',{staticClass:"icon-build-status",domProps:{"innerHTML":_vm._s(_vm.iconBuildStatus)}}),_vm._v(" "),_c('a',{staticClass:"item-build-name",attrs:{"href":build.url}},[_vm._v("\n            "+_vm._s(build.name)+"\n          ")]),_vm._v("\n          ·\n          "),_c('a',{staticClass:"pipeline-id",attrs:{"href":build.url}},[_vm._v("\n            #"+_vm._s(build.id)+"\n          ")]),_vm._v(" "),_c('icon',{attrs:{"name":"fork","size":16}}),_vm._v(" "),_c('a',{staticClass:"ref-name",attrs:{"href":build.branch.url}},[_vm._v("\n            "+_vm._s(build.branch.name)+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"icon-branch",domProps:{"innerHTML":_vm._s(_vm.iconBranch)}}),_vm._v(" "),_c('a',{staticClass:"commit-sha",attrs:{"href":build.commitUrl}},[_vm._v("\n            "+_vm._s(build.shortSha)+"\n          ")])],1),_vm._v(" "),_c('span',[_c('a',{staticClass:"issue-date",attrs:{"href":build.url}},[_vm._v("\n            "+_vm._s(build.date)+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"item-time"},[_c('total-time',{attrs:{"time":build.totalTime}})],1)])}))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./cycle_analytics/components/stage_test_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  stage_test_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_stage_test_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./cycle_analytics/components/total_time_component.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./cycle_analytics/components/total_time_component.vue

/* harmony default export */ var total_time_component = ({
  props: {
    time: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    hasData: function hasData() {
      return Object.keys(this.time).length;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26e64d68","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./cycle_analytics/components/total_time_component.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"total-time"},[(_vm.hasData)?[(_vm.time.days)?[_vm._v("\n      "+_vm._s(_vm.time.days)+"\n      "),_c('span',[_vm._v("\n        "+_vm._s(_vm.n__('day', 'days', _vm.time.days))+"\n      ")])]:_vm._e(),_vm._v(" "),(_vm.time.hours)?[_vm._v("\n      "+_vm._s(_vm.time.hours)+"\n      "),_c('span',[_vm._v("\n        "+_vm._s(_vm.n__('Time|hr', 'Time|hrs', _vm.time.hours))+"\n      ")])]:_vm._e(),_vm._v(" "),(_vm.time.mins && !_vm.time.days)?[_vm._v("\n      "+_vm._s(_vm.time.mins)+"\n      "),_c('span',[_vm._v("\n        "+_vm._s(_vm.n__('Time|min', 'Time|mins', _vm.time.mins))+"\n      ")])]:_vm._e(),_vm._v(" "),(_vm.time.seconds && _vm.hasData === 1 || _vm.time.seconds === 0)?[_vm._v("\n      "+_vm._s(_vm.time.seconds)+"\n      "),_c('span',[_vm._v("\n        "+_vm._s(_vm.s__('Time|s'))+"\n      ")])]:_vm._e()]:[_vm._v("\n    --\n  ")]],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./cycle_analytics/components/total_time_component.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  total_time_component,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_total_time_component = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./cycle_analytics/cycle_analytics_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_translate__ = __webpack_require__("./vue_shared/translate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_banner_vue__ = __webpack_require__("./cycle_analytics/components/banner.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_stage_code_component_vue__ = __webpack_require__("./cycle_analytics/components/stage_code_component.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_stage_plan_component_vue__ = __webpack_require__("./cycle_analytics/components/stage_plan_component.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_stage_component_vue__ = __webpack_require__("./cycle_analytics/components/stage_component.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_stage_review_component_vue__ = __webpack_require__("./cycle_analytics/components/stage_review_component.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_stage_staging_component_vue__ = __webpack_require__("./cycle_analytics/components/stage_staging_component.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_stage_test_component_vue__ = __webpack_require__("./cycle_analytics/components/stage_test_component.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cycle_analytics_service__ = __webpack_require__("./cycle_analytics/cycle_analytics_service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__cycle_analytics_store__ = __webpack_require__("./cycle_analytics/cycle_analytics_store.js");














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__vue_shared_translate__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var OVERVIEW_DIALOG_COOKIE = 'cycle_analytics_help_dismissed';

  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({ // eslint-disable-line no-new
    el: '#cycle-analytics',
    name: 'CycleAnalytics',
    components: {
      banner: __WEBPACK_IMPORTED_MODULE_4__components_banner_vue__["a" /* default */],
      'stage-issue-component': __WEBPACK_IMPORTED_MODULE_7__components_stage_component_vue__["a" /* default */],
      'stage-plan-component': __WEBPACK_IMPORTED_MODULE_6__components_stage_plan_component_vue__["a" /* default */],
      'stage-code-component': __WEBPACK_IMPORTED_MODULE_5__components_stage_code_component_vue__["a" /* default */],
      'stage-test-component': __WEBPACK_IMPORTED_MODULE_10__components_stage_test_component_vue__["a" /* default */],
      'stage-review-component': __WEBPACK_IMPORTED_MODULE_8__components_stage_review_component_vue__["a" /* default */],
      'stage-staging-component': __WEBPACK_IMPORTED_MODULE_9__components_stage_staging_component_vue__["a" /* default */],
      'stage-production-component': __WEBPACK_IMPORTED_MODULE_7__components_stage_component_vue__["a" /* default */]
    },
    data: function data() {
      var cycleAnalyticsEl = document.querySelector('#cycle-analytics');
      var cycleAnalyticsService = new __WEBPACK_IMPORTED_MODULE_11__cycle_analytics_service__["a" /* default */]({
        requestPath: cycleAnalyticsEl.dataset.requestPath
      });

      return {
        store: __WEBPACK_IMPORTED_MODULE_12__cycle_analytics_store__["a" /* default */],
        state: __WEBPACK_IMPORTED_MODULE_12__cycle_analytics_store__["a" /* default */].state,
        isLoading: false,
        isLoadingStage: false,
        isEmptyStage: false,
        hasError: false,
        startDate: 30,
        isOverviewDialogDismissed: __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(OVERVIEW_DIALOG_COOKIE),
        service: cycleAnalyticsService
      };
    },

    computed: {
      currentStage: function currentStage() {
        return this.store.currentActiveStage();
      }
    },
    created: function created() {
      this.fetchCycleAnalyticsData();
    },

    methods: {
      handleError: function handleError() {
        this.store.setErrorState(true);
        return new __WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */]('There was an error while fetching cycle analytics data.');
      },
      initDropdown: function initDropdown() {
        var _this = this;

        var $dropdown = $('.js-ca-dropdown');
        var $label = $dropdown.find('.dropdown-label');

        $dropdown.find('li a').off('click').on('click', function (e) {
          e.preventDefault();
          var $target = $(e.currentTarget);
          _this.startDate = $target.data('value');

          $label.text($target.text().trim());
          _this.fetchCycleAnalyticsData({ startDate: _this.startDate });
        });
      },
      fetchCycleAnalyticsData: function fetchCycleAnalyticsData(options) {
        var _this2 = this;

        var fetchOptions = options || { startDate: this.startDate };

        this.isLoading = true;

        this.service.fetchCycleAnalyticsData(fetchOptions).then(function (resp) {
          return resp.json();
        }).then(function (response) {
          _this2.store.setCycleAnalyticsData(response);
          _this2.selectDefaultStage();
          _this2.initDropdown();
          _this2.isLoading = false;
        }).catch(function () {
          _this2.handleError();
          _this2.isLoading = false;
        });
      },
      selectDefaultStage: function selectDefaultStage() {
        var stage = this.state.stages[0];
        this.selectStage(stage);
      },
      selectStage: function selectStage(stage) {
        var _this3 = this;

        if (this.isLoadingStage) return;
        if (this.currentStage === stage) return;

        if (!stage.isUserAllowed) {
          this.store.setActiveStage(stage);
          return;
        }

        this.isLoadingStage = true;
        this.store.setStageEvents([], stage);
        this.store.setActiveStage(stage);

        this.service.fetchStageData({
          stage: stage,
          startDate: this.startDate
        }).then(function (resp) {
          return resp.json();
        }).then(function (response) {
          _this3.isEmptyStage = !response.events.length;
          _this3.store.setStageEvents(response.events, stage);
          _this3.isLoadingStage = false;
        }).catch(function () {
          _this3.isEmptyStage = true;
          _this3.isLoadingStage = false;
        });
      },
      dismissOverviewDialog: function dismissOverviewDialog() {
        this.isOverviewDialogDismissed = true;
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(OVERVIEW_DIALOG_COOKIE, '1', { expires: 365 });
      }
    }
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./cycle_analytics/cycle_analytics_service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.esm.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

var CycleAnalyticsService = function () {
  function CycleAnalyticsService(options) {
    _classCallCheck(this, CycleAnalyticsService);

    this.requestPath = options.requestPath;
    this.cycleAnalytics = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(this.requestPath);
  }

  _createClass(CycleAnalyticsService, [{
    key: 'fetchCycleAnalyticsData',
    value: function fetchCycleAnalyticsData() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { startDate: 30 };

      return this.cycleAnalytics.get({ cycle_analytics: { start_date: options.startDate } });
    }
  }, {
    key: 'fetchStageData',
    value: function fetchStageData(options) {
      var stage = options.stage,
          startDate = options.startDate;


      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(this.requestPath + '/events/' + stage.name + '.json', {
        params: {
          cycle_analytics: {
            start_date: startDate
          }
        }
      });
    }
  }]);

  return CycleAnalyticsService;
}();

/* harmony default export */ __webpack_exports__["a"] = (CycleAnalyticsService);

/***/ }),

/***/ "./cycle_analytics/cycle_analytics_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./lib/utils/text_utility.js
var text_utility = __webpack_require__("./lib/utils/text_utility.js");

// CONCATENATED MODULE: ./cycle_analytics/default_event_objects.js
/* harmony default export */ var default_event_objects = ({
  issue: {
    created_at: '',
    url: '',
    iid: '',
    title: '',
    total_time: {},
    author: {
      avatar_url: '',
      id: '',
      name: '',
      web_url: ''
    }
  },
  plan: {
    title: '',
    commit_url: '',
    short_sha: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  },
  code: {
    title: '',
    iid: '',
    created_at: '',
    url: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  },
  test: {
    name: '',
    id: '',
    date: '',
    url: '',
    short_sha: '',
    commit_url: '',
    total_time: {},
    branch: {
      name: '',
      url: ''
    }
  },
  review: {
    title: '',
    iid: '',
    created_at: '',
    url: '',
    state: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  },
  staging: {
    id: '',
    short_sha: '',
    date: '',
    url: '',
    commit_url: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    },
    branch: {
      name: '',
      url: ''
    }
  },
  production: {
    title: '',
    created_at: '',
    url: '',
    iid: '',
    total_time: {},
    author: {
      name: '',
      id: '',
      avatar_url: '',
      web_url: ''
    }
  }
});
// CONCATENATED MODULE: ./cycle_analytics/cycle_analytics_store.js
/* eslint-disable no-param-reassign */





var EMPTY_STAGE_TEXTS = {
  issue: Object(locale["a" /* __ */])('The issue stage shows the time it takes from creating an issue to assigning the issue to a milestone, or add the issue to a list on your Issue Board. Begin creating issues to see data for this stage.'),
  plan: Object(locale["a" /* __ */])('The planning stage shows the time from the previous step to pushing your first commit. This time will be added automatically once you push your first commit.'),
  code: Object(locale["a" /* __ */])('The coding stage shows the time from the first commit to creating the merge request. The data will automatically be added here once you create your first merge request.'),
  test: Object(locale["a" /* __ */])('The testing stage shows the time GitLab CI takes to run every pipeline for the related merge request. The data will automatically be added after your first pipeline finishes running.'),
  review: Object(locale["a" /* __ */])('The review stage shows the time from creating the merge request to merging it. The data will automatically be added after you merge your first merge request.'),
  staging: Object(locale["a" /* __ */])('The staging stage shows the time between merging the MR and deploying code to the production environment. The data will be automatically added once you deploy to production for the first time.'),
  production: Object(locale["a" /* __ */])('The production stage shows the total time it takes between creating an issue and deploying the code to production. The data will be automatically added once you have completed the full idea to production cycle.')
};

/* harmony default export */ var cycle_analytics_store = __webpack_exports__["a"] = ({
  state: {
    summary: '',
    stats: '',
    analytics: '',
    events: [],
    stages: []
  },
  setCycleAnalyticsData: function setCycleAnalyticsData(data) {
    this.state = Object.assign(this.state, this.decorateData(data));
  },
  decorateData: function decorateData(data) {
    var newData = {};

    newData.stages = data.stats || [];
    newData.summary = data.summary || [];

    newData.summary.forEach(function (item) {
      item.value = item.value || '-';
    });

    newData.stages.forEach(function (item) {
      var stageSlug = Object(text_utility["d" /* dasherize */])(item.name.toLowerCase());
      item.active = false;
      item.isUserAllowed = data.permissions[stageSlug];
      item.emptyStageText = EMPTY_STAGE_TEXTS[stageSlug];
      item.component = 'stage-' + stageSlug + '-component';
      item.slug = stageSlug;
    });
    newData.analytics = data;
    return newData;
  },
  setLoadingState: function setLoadingState(state) {
    this.state.isLoading = state;
  },
  setErrorState: function setErrorState(state) {
    this.state.hasError = state;
  },
  deactivateAllStages: function deactivateAllStages() {
    this.state.stages.forEach(function (stage) {
      stage.active = false;
    });
  },
  setActiveStage: function setActiveStage(stage) {
    this.deactivateAllStages();
    stage.active = true;
  },
  setStageEvents: function setStageEvents(events, stage) {
    this.state.events = this.decorateEvents(events, stage);
  },
  decorateEvents: function decorateEvents(events, stage) {
    var newEvents = [];

    events.forEach(function (item) {
      if (!item) return;

      var eventItem = Object.assign({}, default_event_objects[stage.slug], item);

      eventItem.totalTime = eventItem.total_time;

      if (eventItem.author) {
        eventItem.author.webUrl = eventItem.author.web_url;
        eventItem.author.avatarUrl = eventItem.author.avatar_url;
      }

      if (eventItem.created_at) eventItem.createdAt = eventItem.created_at;
      if (eventItem.short_sha) eventItem.shortSha = eventItem.short_sha;
      if (eventItem.commit_url) eventItem.commitUrl = eventItem.commit_url;

      delete eventItem.author.web_url;
      delete eventItem.author.avatar_url;
      delete eventItem.total_time;
      delete eventItem.created_at;
      delete eventItem.short_sha;
      delete eventItem.commit_url;

      newEvents.push(eventItem);
    });

    return newEvents;
  },
  currentActiveStage: function currentActiveStage() {
    return this.state.stages.find(function (stage) {
      return stage.active;
    });
  }
});

/***/ }),

/***/ "./cycle_analytics/svg/icon_branch.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\"><path fill=\"#8C8C8C\" fill-rule=\"evenodd\" d=\"M9.678 6.722C9.353 5.167 8.053 4 6.5 4S3.647 5.167 3.322 6.722h-2.6c-.397 0-.722.35-.722.778 0 .428.325.778.722.778h2.6C3.647 9.833 4.947 11 6.5 11s2.853-1.167 3.178-2.722h2.6c.397 0 .722-.35.722-.778 0-.428-.325-.778-.722-.778h-2.6zM4.694 7.5c0-1.09.795-1.944 1.806-1.944 1.01 0 1.806.855 1.806 1.944 0 1.09-.795 1.944-1.806 1.944-1.01 0-1.806-.855-1.806-1.944z\"/></svg>\n"

/***/ }),

/***/ "./cycle_analytics/svg/icon_build_status.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\"><g fill=\"#31AF64\" fill-rule=\"evenodd\"><path d=\"M12.5 7c0-3.038-2.462-5.5-5.5-5.5S1.5 3.962 1.5 7s2.462 5.5 5.5 5.5 5.5-2.462 5.5-5.5zM0 7c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7-7-3.134-7-7z\"/><path d=\"M6.28 7.697L5.045 6.464c-.117-.117-.305-.117-.42-.002l-.614.614c-.11.113-.11.303.007.42l1.91 1.91c.19.19.51.197.703.004l.264-.265L9.997 6.04c.108-.107.107-.293-.01-.408l-.612-.614c-.114-.113-.298-.12-.41-.01L6.28 7.7z\"/></g></svg>\n"

/***/ }),

/***/ "./cycle_analytics/svg/icon_commit.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\"><path fill=\"#8F8F8F\" fill-rule=\"evenodd\" d=\"M28.777 18c-.91-4.008-4.494-7-8.777-7-4.283 0-7.868 2.992-8.777 7H4.01C2.9 18 2 18.895 2 20c0 1.112.9 2 2.01 2h7.213c.91 4.008 4.494 7 8.777 7 4.283 0 7.868-2.992 8.777-7h7.214C37.1 22 38 21.105 38 20c0-1.112-.9-2-2.01-2h-7.213zM20 25c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5z\"/></svg>\n"

/***/ }),

/***/ "./pages/projects/cycle_analytics/show/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cycle_analytics_cycle_analytics_bundle__ = __webpack_require__("./cycle_analytics/cycle_analytics_bundle.js");


document.addEventListener('DOMContentLoaded', __WEBPACK_IMPORTED_MODULE_0__cycle_analytics_cycle_analytics_bundle__["a" /* default */]);

/***/ }),

/***/ "./vue_shared/components/icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/icon.vue


/* This is a re-usable vue component for rendering a svg sprite
  icon

  Sample configuration:

  <icon
    name="retry"
    :size="32"
    css-classes="top"
  />

*/
// only allow classes in images.scss e.g. s12
var validSizes = [8, 12, 16, 18, 24, 32, 48, 72];

/* harmony default export */ var icon = ({
  props: {
    name: {
      type: String,
      required: true
    },

    size: {
      type: Number,
      required: false,
      default: 16,
      validator: function validator(value) {
        return validSizes.includes(value);
      }
    },

    cssClasses: {
      type: String,
      required: false,
      default: ''
    },

    width: {
      type: Number,
      required: false,
      default: null
    },

    height: {
      type: Number,
      required: false,
      default: null
    },

    y: {
      type: Number,
      required: false,
      default: null
    },

    x: {
      type: Number,
      required: false,
      default: null
    }
  },

  computed: {
    spriteHref: function spriteHref() {
      return gon.sprite_icons + '#' + this.name;
    },
    iconSizeClass: function iconSizeClass() {
      return this.size ? 's' + this.size : '';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43441268","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.iconSizeClass, _vm.cssClasses],attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":_vm.y}},[_c('use',_vm._b({},'use',{ 'xlink:href':_vm.spriteHref },false))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_image.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../images/no_avatar.png
var no_avatar = __webpack_require__("../images/no_avatar.png");
var no_avatar_default = /*#__PURE__*/__webpack_require__.n(no_avatar);

// EXTERNAL MODULE: ./lazy_loader.js
var lazy_loader = __webpack_require__("./lazy_loader.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue


/* This is a re-usable vue component for rendering a user avatar that
  does not need to link to the user's profile. The image and an optional
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-image
    :lazy="true"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :tooltip-text="tooltipText"
    tooltip-placement="top"
  />

*/





/* harmony default export */ var user_avatar_image = ({
  name: 'UserAvatarImage',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    lazy: {
      type: Boolean,
      required: false,
      default: false
    },
    imgSrc: {
      type: String,
      required: false,
      default: no_avatar_default.a
    },
    cssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: 'user avatar'
    },
    size: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    }
  },
  computed: {
    // API response sends null when gravatar is disabled and
    // we provide an empty string when we use it inside user avatar link.
    // In both cases we should render the defaultAvatarUrl
    sanitizedSource: function sanitizedSource() {
      return this.imgSrc === '' || this.imgSrc === null ? no_avatar_default.a : this.imgSrc;
    },
    resultantSrcAttribute: function resultantSrcAttribute() {
      return this.lazy ? lazy_loader["b" /* placeholderImage */] : this.sanitizedSource;
    },
    tooltipContainer: function tooltipContainer() {
      return this.tooltipText ? 'body' : null;
    },
    avatarSizeClass: function avatarSizeClass() {
      return 's' + this.size;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ce3616","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"avatar",class:( _obj = {
    lazy: _vm.lazy
  }, _obj[_vm.avatarSizeClass] = true, _obj[_vm.cssClasses] = true, _obj ),attrs:{"src":_vm.resultantSrcAttribute,"width":_vm.size,"height":_vm.size,"alt":_vm.imgAlt,"data-src":_vm.sanitizedSource,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement,"title":_vm.tooltipText}})
var _obj;}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_image,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_image = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/directives/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    $(el).tooltip();
  },
  componentUpdated: function componentUpdated(el) {
    $(el).tooltip('fixTitle');
  },
  unbind: function unbind(el) {
    $(el).tooltip('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./pages/projects/cycle_analytics/show/index.js"]);


// WEBPACK FOOTER //
// pages.projects.cycle_analytics.show.cbc93a7c88a253fd3ac3.bundle.js